import CartDrawer from './common/cartDrawer';
import Footer from './common/footer';
// import './common/functions';
import './common/topbar.js'
// import './common/count';

import './common/topbarCount'
import './common/slides';
import Header from './common/header';
import MenuMobile from './common/menuMobile';
import Popup from './components/popup';
import Webforms from './common/webforms';
import ProductPurchase from './components/productPurchase';
import { NewsletterComponent, PriceComponent } from './components/vndaComponents.js';
import { setSearch , landingPage } from './components/utilities';
import selectionBlockColors from './components/selectionBlockColors.js';
import login from './components/login.js';
let threshold = 700;
if (window.innerWidth < 768) threshold = 400 ;

import { getClient } from './components/utilities';

window.lazyLoadOptions = {
  elements_selector: ".lazy",
  threshold,
  callback_loaded: (el) => {
    const element = el.closest('.MagicZoom');
    if (element && element.id) {
      MagicZoom && MagicZoom.refresh(element.id);
    }
  },
};

window.addEventListener("LazyLoad::Initialized", event => {
  window.lazyLoadInstance = event.detail.instance
}, { passive: true });

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cVnda - Tecnologia em Ecommerce',
  'color: #f88d5b; font-size: 15px; font-family: "Verdana", sans-serif; font-weight: bold;'
);


// Importando pacotes Algolia
import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import {
  searchBox,
  hits,
  configure,
  pagination,
  hitsPerPage,
} from "instantsearch.js/es/widgets";

//Adicionando as chaves do Algolia. Substitua os campos com as chaves do Algolia.
// const searchClient = algoliasearch(
//       'EFQKX3ZUV7', 
//       '521505710ccdc62bc30db0a5d6562ddc'
// );

// const search = instantsearch({
//   indexName: "products",
//   searchClient,
// });

// search.addWidgets([
//   configure({
//     hitsPerPage: window.innerWidth > 767 ? 4 : 2,
//     filters: 'active = 1'
//   }),
//   searchBox({
//     container: document.querySelector("#algolia-search"),
//     placeholder: "Buscar por...",
//     showReset: false,
//     showSubmit: false,
//   }),
//   hits({
//     container: document.querySelector("#hits"),
//     templates: {
//       item(hit) {
//         let sobConsulta = false;
//         hit.tags.forEach((e) => {
//           if (e.name == "sob-consulta") {
//             sobConsulta = true;
//           }
//         });
//         let img = hit.image_url
//           ? hit.image_url
//           : "http://placehold.it/500x500";
//         let price = "";
//         if (hit.price && hit.sale_price) {
//           let discountPix = hit.price * pixPercentDiscount;

//           if (hit.price != hit.sale_price) {
//             price =
//               "<del>" +
//               store.formatMoney(hit.price - discountPix) +
//               "</del>";
//           }
//           price +=
//             "<ins>" +
//             store.formatMoney(hit.sale_price - discountPix) +
//             "</ins><span> à vista</span>";
//         }

//         let maxParcelsWithoutInterestText = "";
//         let maxParcelsText = "";

//         if (hit.instalments) {
//           var maxParcels = hit.instalments;
//           maxParcelsText = `ou ${maxParcels.length}x de ${store.formatMoney(
//             maxParcels[maxParcels.length - 1].price
//           )}`;

//           var maxParcelsWithoutInterest = hit.instalments.filter(
//             (el) => el.interest === false
//           );
//           maxParcelsWithoutInterestText = `${
//             maxParcelsWithoutInterest.length
//           }x de ${store.formatMoney(
//             maxParcelsWithoutInterest[maxParcelsWithoutInterest.length - 1]
//               .price
//           )} sem juros`;
//         }

//         let name = hit.name;

//         if (!hit.name) {
//           name = "";
//         }

//         return `
//           <div class="product-block">
//             <a href="${hit.url}" class="link">
//               <div class="images">
//                 <figure>
//                   <img src="${img}" />
//                 </figure>
//               </div>
//               <div class="text">
//                 <p class="title">${name}</p>

//                 <div class="wrapper-price ${sobConsulta ? "-hidden" : ""}">
//                   <p class="price">${price}</p>
//                   <div class="parcels">
//                     <p class="without-interest">${maxParcelsWithoutInterestText}</p>
//                   </div>
//                 </div>
//                 <div class="wrapper-price ${sobConsulta ? "" : "-hidden"}">
//                   <p>Sob consulta</p>
//                 </div>
//               </div>
//             </a>
//           </div>
//         `;
//       },
//     },
//   }),
//   pagination({
//     container: document.querySelector("#hits-pagination"),
//     showFirst: false,
//     showPrevious: false,
//     showNext: false,
//     showLast: false,
//   }),
// ]);

// search.start();

export default function modalCorreios(){
    
  const closePopModal = document.querySelectorAll('.close_modal');
  const modalCorreios = document.querySelector('.modal_correios');
  
  if(modalCorreios) {
     // Sempre remove a classe 'hidden' quando a página carrega
    modalCorreios.classList.remove('hidden');
    
    // Verifica se o usuário já fechou a newsletter anteriormente
    if (localStorage.getItem('correiosClosed') === 'true') {
        modalCorreios.classList.add('hidden');
    }
    
    closePopModal.forEach(closeBtn => {
        closeBtn.addEventListener('click', () => {
        // Adiciona a classe 'hidden' ao modalCOrreios
        modalCorreios.classList.add('hidden');
    
        // Armazena a informação no localStorage
        localStorage.setItem('correiosClosed', 'true');
        });
    });
  }

}


window.addEventListener('DOMContentLoaded', () => {
  CartDrawer.init();
  Header.init();
  Footer.init();
  if (window.innerWidth <= 1024) MenuMobile.init()
  PriceComponent.init();
  Popup.init();
  ProductPurchase.init();
  Webforms.init();
  NewsletterComponent.init();
  setSearch();
  selectionBlockColors.init();
  landingPage();
  modalCorreios();
  login();

 
  // Seleciona todos os elementos com a classe .product-block
  const productBlocks = document.querySelectorAll('.product-block');

  // Itera sobre cada elemento .product-block
  productBlocks.forEach(productBlock => {
    // Verifica se o produto possui uma div com a classe .colors-selection
    const colorsSelection = productBlock.querySelector('.colors-selection');
    
    // Se colorsSelection não for nulo (ou seja, se existir)
    if (colorsSelection) {
      // Adiciona a classe more-colors ao productBlock
      productBlock.classList.add('more-colors');
    }
  });

  setTimeout(function() {
    $('.product-block').each(function() {
      var $productBlock = $(this);
      var $pix = $productBlock.find('.pix');
      var $price = $productBlock.find('.cmp-price-price');
      var $salePrice = $productBlock.find('.cmp-price-sale-price');
      
      if ($salePrice.length > 0) {
        $pix.insertAfter($salePrice);
      } else {
        $pix.insertAfter($price);
      }
    });
  }, 2000);

  $('.filter-container #component-products-filter-root .component-products-filter-py-4').on('click', function() {
    $('.filter-container #component-products-filter-root .vnda-products-filter-horizontal-properties-header, .filter-container #component-products-filter-root .vnda-products-filter-horizontal-sort-header, .filter-container #component-products-filter-root .vnda-products-filter-horizontal-tags-header, .filter-container #component-products-filter-root .vnda-products-filter-price-filter-header').toggleClass('rotated');
  });

});
